import { Pipe, PipeTransform } from '@angular/core';
import { ConsultantCaseStatus, PatientCaseStatus } from 'src/app/landing/active-case/status.interface';
import { CommonDataService } from '../services/common-data.service';


@Pipe({ name: 'caseStatus' })
export class CaseStatus implements PipeTransform {
  constructor(private _dataService: CommonDataService) { }
  transform(dataItem: any, colField?: string) {
    if (colField && dataItem) {
      const data = dataItem[colField];
      const role = this._dataService.role;
      const getKeyValue = <T extends object, U extends keyof T>(obj: T) => (key: U) =>
        obj[key];
      let status = '';
      switch (role) {
        case 'patient':
          status = getKeyValue(PatientCaseStatus)(data);
          break;
        case 'consultant':
          status = getKeyValue(ConsultantCaseStatus)(data);
          break;
      }
      return status;
    }
    return null;
  }
}
